import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { loginPathFor } from 'utils/safeRedirect'

/**
 * `PrivateRoute` as a pathless layout route, so a whole subtree is guarded once.
 *
 * Every protected route in `AppRoutes` wraps its own element in `PrivateRoute`,
 * because there is no shared protected layout. That is fine for a flat list of
 * screens added one at a time, but the field app is a subtree with its own
 * chrome, and wrapping each of its routes individually would repeat the same
 * guard for no benefit.
 *
 * The auth check is deliberately identical to `PrivateRoute`'s rather than
 * improved here: two components disagreeing about what "signed in" means is a
 * bug waiting to happen. If that check changes, it changes in both.
 */
const PrivateOutlet = () => {
	const location = useLocation()
	const userLogin = useSelector((state: any) => state.userLogin)
	const isLoggedIn = userLogin.userInfo !== null && userLogin.userInfo !== undefined

	if (!isLoggedIn) {
		// Remember the page, so signing in lands there (MYD-541).
		return <Navigate to={loginPathFor(location)} replace />
	}

	return <Outlet />
}

export default PrivateOutlet
